import type SearchTableQuery from "../store/schema/SearchTableQuery";
import type { OwaDate } from "owa-datetime";
import type { TableQuery } from "owa-mail-list-store";
import { type TableQueryType } from "owa-mail-list-store";
import type { PillSuggestion } from "owa-search-service/lib/data/schema/SuggestionSet";
import type { SearchScope, SearchScopeForFolder, } from "owa-search-service/lib/data/schema/SearchScope";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import type { SearchProvider } from "owa-search-service";
import type ViewFilter from "owa-service/lib/contract/ViewFilter";
import type { SearchSortOrder, SearchTableScenarioType } from "../store/schema/SearchTableQuery";
import type { SearchTab } from "owa-search-types/lib/types/SearchTab";
import type { SearchScenarioId } from "owa-search-store/lib/store/schema/SearchScenarioId";
import { isSubjectSearchSortOrder } from "./clientSearchSortOrder";

/**
 * Creates the table query for search table.
 */
export default function createMailSearchTableQuery(searchScenarioId: SearchScenarioId, searchNumber: number, queryString: string, searchScope: SearchScope, selectedPillSuggestions: Map<string, PillSuggestion>, listViewType: ReactListViewType, includeAttachments: boolean, fromDate: OwaDate | undefined, toDate: OwaDate | undefined, searchProvider: SearchProvider, scenarioType: SearchTableScenarioType, appliedFilter?: ViewFilter, searchTab?: SearchTab, entityRecognitionApplied?: boolean, entityRecognitionDisplayQuery?: string, searchSortOrder?: SearchSortOrder, searchTextAtSubmission?: string, queryStringBeforeEntityRecognition?: string): TableQuery {
    const pillSuggestions = [...selectedPillSuggestions.values()];
    
    const searchTableQuery: SearchTableQuery = {
        searchScenarioId,
        folderId: (searchScope as SearchScopeForFolder).folderId,
        type: 1,
        // Folder Subject sort is message-based; changing shape needs a fresh result set.
        listViewType: isSubjectSearchSortOrder(searchSortOrder)
            ? 1 : listViewType,
        searchNumber,
        queryString,
        searchTextAtSubmission,
        entityRecognitionApplied,
        entityRecognitionDisplayQuery,
        queryStringBeforeEntityRecognition,
        searchScope,
        pillSuggestions,
        includeAttachments,
        fromDate,
        toDate,
        scenarioType,
        lastIndexFetched: 0,
        maxRowsLoadedFromServer: 0,
        searchProvider,
        searchSortOrder,
        displaySearchSortOrder: undefined,
        viewFilter: appliedFilter ? appliedFilter : "All",
        searchTab,
        allMailboxSearchContexts: undefined,
    };
    
    return searchTableQuery;
}
